<div
  #sectionContainer
  class="section-container empty-container empty-container-that-matches-color-of-following-product-section"
  [style.height.px]="section?.heightInPx"
  [style.background-color]="section?.backgroundColor"></div>
